module.exports = __webpack_public_path__ + "img/avalanche.b2914932.png";